import { useDrawerStore } from '@ContractBuilder/store/drawer.store';

import { TemplateValidationChecks } from '../components/TemplateValidationChecks';

export const TemplateValidationPanelController = () => {
  const closeDrawer = useDrawerStore(({ closeDrawer }) => closeDrawer);

  return <TemplateValidationChecks onClose={closeDrawer} />;
};
